import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

// import fa from "vuetify/lib/locale/fa";
// icons
import Search from "./../components/icons/Search.vue";
import Send from "../components/icons/Send.vue";
import Select from "../components/icons/Select.vue";
import ArrowLeft from "../components/icons/ArrowLeft.vue";
import Zoom from "../components/icons/Zoom.vue";
import Location from "../components/icons/Location.vue";
import Phone from "../components/icons/Phone.vue";
import Email from "../components/icons/Email.vue";
import Url from "../components/icons/Url.vue";
import Close from "../components/icons/Close.vue";
import Edit from "../components/icons/Edit.vue";
import Trash from "../components/icons/Trash.vue";
import File from "../components/icons/File.vue";
import Star from "../components/icons/Star.vue";
import Pen from "../components/icons/Pen.vue";
import Word from "../components/icons/Word.vue";
import Excel from "../components/icons/Excel.vue";
import Camera from "../components/icons/Camera.vue";

Vue.use(Vuetify);
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

export default new Vuetify({
  // lang: {
  //   locales: { fa },
  //   current: "fa",
  // },
  rtl: true,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#3A82B5",
        // secondary: "#FFB7B7",
        secondary: "#FFDCA5",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    values: {
      searchIcon: {
        component: Search,
      },
      sendIcon: {
        component: Send,
      },
      selectIcon: {
        component: Select,
      },
      ArrowLeft: {
        component: ArrowLeft,
      },
      zoomIcon: {
        component: Zoom,
      },
      Location: {
        component: Location,
      },
      Phone: {
        component: Phone,
      },
      Email: {
        component: Email,
      },
      Url: {
        component: Url,
      },
      Close: {
        component: Close,
      },
      Edit: {
        component: Edit,
      },
      Trash: {
        component: Trash,
      },
      File: {
        component: File,
      },
      Star: {
        component: Star,
      },
      Pen: {
        component: Pen,
      },
      Word: {
        component: Word,
      },
      Excel: {
        component: Excel,
      },
      Camera: {
        component: Camera,
      },
    },
  },
});
